<template>
  <central-modal
    :modalClass="'ModalBox--medium'"
    :footerClass="'ModalBox--footer'"
    hideClose
  >
    <template slot="header">
      <div class="Tit Tit--modal w-100"> {{$t('transactions_filter_create_filtered_view_modal_header')}}</div>
    </template>
    <template slot="content">
      <p class="Fuell-Text text-center"> {{$t('transactions_filter_create_filtered_view_modal_info')}}</p>

      <div class="Form-field mx-0">
        <input
          type="text"
          class="Input-text"
          :placeholder="$t('transactions_filter_create_filtered_view_modal_placeholder')"
          v-model="filteredViewName"
        >

      </div>

    </template>
    <template slot="footer">

      <div
        class="Fuell-Button d-flex flex-shrink-1 danger"
        @click="closeModal"
      >
        <span class="Fuell-Buton--label w-100 text-center ">{{$t('ACTION_CANCEL')}} </span>
      </div>
      <div
        class="Fuell-Button d-flex flex-grow-1 blue ml-3"
        :disabled="$v.$invalid"
        @click="createFilteredView"
      >
        <span class="Fuell-Button--label w-100 text-center"> {{$t('transactions_filter_create_filtered_view_modal_action_confirm')}}</span>
      </div>

    </template>

  </central-modal>
</template>

<script>
import CentralModal from '@/components/Commons/Modals/CentralModal'
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')
export default {
  name: 'CreateNewQuickFilterModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: {
    CentralModal
  },
  data () {
    return {
      filteredViewName: ''
    }
  },
  methods: {
    createFilteredView () {
      this.$emit('createFilteredView', this.filteredViewName)
      this.closeModal()
    }
  },
  validations: {
    filteredViewName: {
      required
    }
  }

}
</script>

<style>
.ModalBox--medium {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  max-width: 412px;
}
.ModalBox--footer {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 24px 0px 0px 0px;
}

</style>
